<template>
  <div class="cases">
    <el-button type="primary" @click="openDialog()">新增</el-button>
    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="序号" width="180"></el-table-column>
      <el-table-column prop="field" label="键" width="180"></el-table-column>
      <el-table-column prop="value" label="值"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        layout="sizes, prev, pager, next"
        :page-sizes="[5, 10, 15, 20]"
        :total="total"
        :current-page="page"
        :page-size="size"
        @current-change="currentChange"
        @size-change="sizeChange"
    ></el-pagination>
    <el-dialog title="案例编辑" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <el-form-item label="数据键" :label-width="formLabelWidth">
          <el-input v-model="formData.field" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="数据键" :label-width="formLabelWidth">
          <el-input v-model="formData.value" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      page: 1,
      size: 10,
      tableData: [],
      total: 0,
      formData: {
        id: 0,
        field: "",
        value: "",
        time: new Date()
      },
      options: {}
    };
  },
  mounted() {
    let token = "Bearer " + sessionStorage.getItem("token");
    this.options = {headers: {Authorization: token}}
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http.get(`dict/list?page=${this.page}&size=${this.size}`, this.options).then(response => {
          this.tableData = response.data.list;
          this.loading = false;
        }).catch(e => {
          this.$message({
            message: e.message,
            type: "error"
          })
        })
    },
    openDialog() {
      this.formData.id = 0;
      this.formData.field = "";
      this.formData.value = "";
      this.formData.time = new Date();
      this.dialogFormVisible = true;
    },
    handleCreateOrModify() {
      this.loading = true;
      this.$http.post("dict/edit", this.formData, this.options).then(() => {
        this.loading = false;
        this.$message({
          message: "创建成功！",
          type: "success"
        });
        this.dialogFormVisible = false;
        this.loadData();
      }).catch(e => {
        this.$message({
          message: "网络或程序异常！" + e,
          type: "error"
        });
      });
    },
    handleEdit(index, row) {
      this.formData = row;
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          this.loading = true;
          this.$http.post(
              `dict/delete?id=${row.id}`,
              null,
              this.options
            ).then(() => {
              this.loading = false;
              this.$message({
                message: "删除成功！",
                type: "success"
              });
              this.loadData();
            }).catch(e => {
              this.$message({
                message: e.message,
                type: "error"
              })
            })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          })
        })
    },
    currentChange(val) {
      this.page = val;
      this.loadData();
    },
    sizeChange(val) {
      this.size = val;
      this.loadData();
    },
    dateFormat: function(row) {
      let t = new Date(row.time);
      return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate();
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>